

















import Component from 'vue-class-component'
import { Prop, Vue } from 'vue-property-decorator'
import zoneStore from '@/stores/ZoneStore'
import Zone from '@/dto/Zone/Zone'
import ZoneItem from '@/dto/Zone/ZoneItem'

@Component
export default class ZoneItemsHeader extends Vue {
  @Prop(Object)
  model: Zone

  isPending: boolean = false

  zoneStore = zoneStore

  back() {
    this.zoneStore.selectZone(null)
  }

  get label(): string {
    return `Зона ${this.model.name}`
  }
}
